
import { Component, Mixins } from "vue-property-decorator";
import mixin from "./mixin";
import { estimatedReceiveDateModal } from "@/lib/modals";
import notifications from "@/lib/notifications";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules";
import VisibleOptions from "@/components/widgets/VisibleOptions.vue";

const orderModule = getModule(OrderModule);

@Component({
  name: estimatedReceiveDateModal,
  components: {
    VisibleOptions
  }
})
export default class EstimatedReceiveDateModal extends Mixins(mixin) {
  saving: boolean = false;
  estimatedReceiveDate: Date | string = null;
  note: any = { text: null, visibleOption: "0", customerViewable: true, facilityViewable: true };

  load() {
    this.show();
    const selectedDates = (this.selectedItems || []).map(item => item?.anticipatedReceiveDate ?? null);
    const firstSelectedDate = selectedDates.length > 0 ? selectedDates[0] : null;

    this.estimatedReceiveDate = selectedDates.every(date => this.isSameDateValue(date, firstSelectedDate))
      ? firstSelectedDate
      : null;
  }

  reset() {
    this.estimatedReceiveDate = null;
    this.note = { text: null, visibleOption: "0", customerViewable: true, facilityViewable: true };
  }

  changeVisibleTo(value) {
    let visibleOption = "1";
    if (value.customerViewable && value.facilityViewable) {
      visibleOption = "0";
    } else if (value.customerViewable) {
      visibleOption = "2";
    } else if (value.facilityViewable) {
      visibleOption = "3";
    }

    this.note = { ...this.note, ...value, visibleOption };
  }

  isSameDateValue(leftDate: Date | string | null, rightDate: Date | string | null) {
    return this.normalizeDateValue(leftDate) === this.normalizeDateValue(rightDate);
  }

  normalizeDateValue(dateValue: Date | string | null) {
    if (!dateValue) return null;

    const normalizedDate = new Date(dateValue);
    return Number.isNaN(normalizedDate.getTime()) ? String(dateValue) : normalizedDate.toISOString();
  }

  getSelectedOrderNumbers() {
    return Array.from(
      new Set(
        (this.selectedItems || [])
          .map(item => Number(item?.headerNumber || item?.number))
          .filter(orderNumber => !Number.isNaN(orderNumber))
      )
    );
  }

  async save() {
    const orderNumbers = this.getSelectedOrderNumbers();
    if (orderNumbers.length === 0 || !this.estimatedReceiveDate) return;

    this.saving = true;
    try {
      await orderModule.updateEstimatedReceiveDate({
        orderNumbers,
        anticipatedReceiveDate: this.estimatedReceiveDate,
        orderNote: this.note?.text?.trim() ? this.note : null
      });

      notifications.success(
        "Estimated Receive Date",
        `Estimated Receive Date successfully updated for ${orderNumbers.length} order${orderNumbers.length === 1 ? "" : "s"}.`
      );
      await this.refreshOrders();
      this.hideModal();
    } catch (ex) {
      notifications.error("Estimated Receive Date", "Failed to update estimated receive date", ex);
    } finally {
      this.saving = false;
    }
  }
}
